import Autocomplete, { AutocompleteClassKey, AutocompleteRenderInputParams, AutocompleteRenderOptionState } from "@material-ui/lab/Autocomplete";
import { ClassNameMap } from "@mui/material";
import React, { memo } from "react";
const GolAutoComplete = (props: {
    id: string,
    size?: "small" | "medium"
    getOptionLabel: (option: any) => string, value: any, options: any, classes?: Partial<ClassNameMap<AutocompleteClassKey>> | undefined,
    renderInput: (params: AutocompleteRenderInputParams) => JSX.Element, renderOption: (options: any, state: any) => JSX.Element,
    onChange: (event: React.ChangeEvent<{}>, value: any) => void
}) => {
    return <Autocomplete
        fullWidth
        id={props.id}
        disableClearable
        size={props.size ?? "small"}
        options={props.options}
        value={props.value}
        classes={props.classes}
        autoHighlight
        getOptionLabel={props.getOptionLabel}
        renderOption={props.renderOption}
        onChange={props.onChange}
        renderInput={props.renderInput}
    />
};

export default memo(GolAutoComplete);